export const members = [
  {
    name: 'World Vision International',
    focus: 'Child Protection & DRR',
    type: 'international',
    logo: 'World_Vision_logo.svg.png',
  },
  { name: 'CARE International', focus: 'Food Security & WASH', type: 'international', logo: 'care.png' },
  { name: 'CRS', focus: 'Relief & Development', type: 'international', logo: 'CRS-logo.jpg' },
  { name: 'Save the Children Intl.', focus: 'Child Rights & Response', type: 'international', logo: 'save-the-children-2017_6.png' },
  {
    name: 'Danish Refugee Council',
    focus: 'Protection & Shelter',
    type: 'international',
    logo: 'danishrefugeecouncil.png',
  },
  { name: 'Medical Teams', focus: 'Health & Medical Response', type: 'international', logo: 'mti-logo-full-color-rgb-900px-w-72ppi.png' },
  { name: 'WaterAid', focus: 'WASH & Sanitation', type: 'international', logo: 'wateraid.jpg' },
  { name: 'Water Mission', focus: 'Clean Water Access', type: 'international', logo: 'watermission.jpg' },
  { name: 'Plan International', focus: 'Gender & Child Resilience', type: 'international', logo: 'plan_international.jpeg' },
  { name: 'Jhpiego', focus: 'Maternal & Health Systems', type: 'international', logo: 'jhpiego.png' },
  { name: 'Caritas', focus: 'Social Services & Relief', type: 'international', logo: 'caritas.jpeg' },
  { name: 'Médecins Sans Frontières', focus: 'Emergency Medical Care', type: 'international', logo: 'msf_logo.svg.png' },
  { name: 'HWPL', focus: 'Peace & Humanitarian Work', type: 'international', logo: 'hwpl.png' },
  {
    name: 'We World Tanzania',
    focus: 'Humanitarian & Development',
    type: 'international',
    logo: 'We World Tanzania-1.png',
  },
  {
    name: 'RAPID-Tanzania',
    focus: 'DRR & Coordination Hub',
    type: 'national',
    status: 'Founding Member',
    logo: 'rapidtanzania.png',
  },
  {
    name: 'Tanzania Red Cross Society',
    focus: 'Emergency & First Aid',
    type: 'national',
    status: 'Founding Member',
    logo: 'redcrosssociety.png',
  },
  { name: 'KOVA Foundation', focus: 'Community Resilience', type: 'national', logo: 'KOVAfoundation.webp' },
  { name: 'Art in Tanzania', focus: 'Community Development', type: 'national', logo: 'artintanzania.jpeg' },
  { name: 'Kituja Foundation', focus: 'Youth & Humanitarian Action', type: 'national', logo: 'kituja.jpeg' },
  { name: 'HUDEFO', focus: 'Human Development & Relief', type: 'national', logo: 'hudefo.png' },
  { name: 'CARE-USTZ', focus: 'Research & Field Programs', type: 'national', logo: 'care.jpeg' },
  { name: 'Sisi Tanzania', focus: 'Community & Humanitarian Action', type: 'national', logo: 'sisitanzania.jpeg' },
  { name: 'SUKOS', focus: 'Community Development & Relief', type: 'national', logo: 'sukos.jpeg' },
  {
    name: 'Tanganyika Christian Refugees Services (TCRS)',
    focus: 'Refugee Services & Protection',
    type: 'national',
    logo: 'Tanganyika Christian Refugees Services (TCRS).png',
  },
  {
    name: 'G4TC (Green 4 Tomorrow Climate)',
    focus: 'Climate & Environmental Action',
    type: 'national',
    logo: 'c4tc.jpeg',
  },
  {
    name: 'ENVIROCARE',
    focus: 'Environment, Human Rights & Gender',
    type: 'national',
    logo: 'envirocare.png',
  },
];
